import {ContainerBinder} from '../../../IoC/ContainerBinder';
import {DataFilterStore} from '../stores/DataFilter/DataFilter.store';
import {DataFilterDatesManagerStore} from '../stores/DataFilterDatesManager/DataFilterDatesManager.store';
import {DataFilterFieldsManagerStore} from '../stores/DataFilterFieldsManager/DataFilterFieldsManager.store';
import {DataFilterLabelsStore} from '../stores/DataFilterLabels/DataFilterLabels.store';
import {DataFilterSearchManagerStore} from '../stores/DataFilterSearchManager/DataFilterSearchManager.store';
import {DataFilterStorageManagerStore} from '../stores/DataFilterStorageManager/DataFilterStorageManager.store';

export const bindDataFilterModule = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bind(DataFilterDatesManagerStore)
    .bind(DataFilterFieldsManagerStore)
    .bind(DataFilterSearchManagerStore)
    .bind(DataFilterStorageManagerStore)
    .bind(DataFilterStore)
    .bindSingleton(DataFilterLabelsStore)
    .done();
};
